import { lazy } from 'react';
import { Skeleton } from '@picsart/design-system/components/Skeleton';
import withSuspense from '../withSuspense/index.js';

var AllowedWeights;
(function (AllowedWeights) {
  AllowedWeights["Regular"] = "normal";
  AllowedWeights["SemiBold"] = "semibold";
  AllowedWeights["Medium"] = "medium";
})(AllowedWeights || (AllowedWeights = {}));
var AllowedTextSizes;
(function (AllowedTextSizes) {
  AllowedTextSizes["Large"] = "large";
  AllowedTextSizes["Small"] = "small";
  AllowedTextSizes["Custom"] = "custom";
})(AllowedTextSizes || (AllowedTextSizes = {}));

var testIds = {
  descriptionRoot: 'description-root'
};

var Description = withSuspense(/*#__PURE__*/lazy(function () {
  return import('../Description-96904a06.js');
}), Skeleton);

export { AllowedTextSizes, AllowedWeights, Description as default, testIds };
//# sourceMappingURL=index.js.map
